
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Shop() {
  const [selectedCategory, setSelectedCategory] = useState('alle');
  const [sortBy, setSortBy] = useState('name');

  const categories = [
    { id: 'alle', name: 'Alle Produkte', count: 16 },
    { id: 'eco', name: 'ECO Version', count: 4 },
    { id: 'premium', name: 'PREMIUM Version', count: 4 },
    { id: 'module', name: 'Module', count: 8 }
  ];

  const products = [
    {
      id: 1,
      name: 'baufaktura ECO',
      price: '275,00 €',
      originalPrice: null,
      category: 'eco',
      image: 'https://public.readdy.ai/ai/img_res/70c0a1d90b9902fb7d47ed6c39a214d6.jpg',
      inStock: true,
      isUpdate: false,
      description: 'Die Grundausstattung für Ihren Handwerksbetrieb'
    },
    {
      id: 2,
      name: 'baufaktura ECO Update V15.0',
      price: '165,00 €',
      originalPrice: null,
      category: 'eco',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20package%20box%20for%20construction%20management%20software%20ECO%20update%20version%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20product&width=300&height=300&seq=eco-update-box&orientation=squarish',
      inStock: true,
      isUpdate: true,
      description: 'Update auf die neueste ECO Version'
    },
    {
      id: 3,
      name: 'baufaktura PREMIUM',
      price: '495,00 €',
      originalPrice: null,
      category: 'premium',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20package%20box%20for%20construction%20management%20software%20PREMIUM%20version%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20product&width=300&height=300&seq=premium-box&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Die Vollversion mit allen Funktionen'
    },
    {
      id: 4,
      name: 'baufaktura PREMIUM Update V15.0',
      price: '245,00 €',
      originalPrice: null,
      category: 'premium',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20package%20box%20for%20construction%20management%20software%20PREMIUM%20update%20version%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20product&width=300&height=300&seq=premium-update-box&orientation=squarish',
      inStock: true,
      isUpdate: true,
      description: 'Update auf die neueste PREMIUM Version'
    },
    {
      id: 5,
      name: 'FORMULARSCHNITTSTELLE',
      price: '75,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20form%20interface%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=form-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Modul für Formularschnittstellen'
    },
    {
      id: 6,
      name: 'PREMIUM-SCHNITTSTELLE GAEB DATV Export',
      price: '195,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20GAEB%20interface%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=gaeb-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'GAEB Schnittstelle für Datenexport'
    },
    {
      id: 7,
      name: 'PREMIUM-ZUSATZMODUL Aufmaß Erweiterung',
      price: '495,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20measurement%20extension%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=aufmass-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Erweiterte Aufmaß-Funktionen'
    },
    {
      id: 8,
      name: 'PREMIUM-ZUSATZMODUL Jahresverträge',
      price: '245,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20annual%20contracts%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=contracts-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Verwaltung von Jahresverträgen'
    },
    {
      id: 9,
      name: 'PREMIUM-ZUSATZMODUL Lieferscheinaufstellung',
      price: '75,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20delivery%20note%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=delivery-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Automatische Lieferscheinaufstellung'
    },
    {
      id: 10,
      name: 'PREMIUM-ZUSATZMODUL Passwort-Verwaltung',
      price: '245,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20password%20management%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=password-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Sichere Passwort-Verwaltung'
    },
    {
      id: 11,
      name: 'PREMIUM-ZUSATZMODUL Terminkalender-Installation',
      price: '245,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20calendar%20installation%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=calendar-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Integrierte Terminkalender-Lösung'
    },
    {
      id: 12,
      name: 'SCHNITTSTELLE Buchhaltungsschnittstelle',
      price: '195,00 €',
      originalPrice: null,
      category: 'module',
      image: 'https://readdy.ai/api/search-image?query=Professional%20blue%20software%20module%20box%20for%20accounting%20interface%20module%2C%20clean%20product%20photography%2C%20white%20background%2C%20modern%20design%2C%20German%20software%20addon&width=300&height=300&seq=accounting-module&orientation=squarish',
      inStock: true,
      isUpdate: false,
      description: 'Schnittstelle zur Buchhaltung'
    }
  ];

  const filteredProducts = products.filter(product => 
    selectedCategory === 'alle' || product.category === selectedCategory
  );

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === 'name') {
      return a.name.localeCompare(b.name);
    } else if (sortBy === 'price') {
      const priceA = parseFloat(a.price.replace(/[€,\s]/g, '').replace(',', '.'));
      const priceB = parseFloat(b.price.replace(/[€,\s]/g, '').replace(',', '.'));
      return priceA - priceB;
    }
    return 0;
  });

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Unser Shop
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Hier finden Sie unsere Produkte
            </p>
          </div>
        </div>
      </section>

      {/* Shop Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8">
            
            {/* Sidebar */}
            <div className="lg:w-1/4">
              <div className="bg-white rounded-lg border border-gray-200 p-6 sticky top-24">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Kategorien</h3>
                <div className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full text-left px-3 py-2 rounded-lg transition-colors cursor-pointer ${
                        selectedCategory === category.id
                          ? 'bg-blue-100 text-blue-700 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex justify-between items-center">
                        <span>{category.name}</span>
                        <span className="text-sm text-gray-400">({category.count})</span>
                      </div>
                    </button>
                  ))}
                </div>

                <div className="mt-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Sortieren nach</h3>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-8"
                  >
                    <option value="name">Name</option>
                    <option value="price">Preis</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Products Grid */}
            <div className="lg:w-3/4">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                  {categories.find(cat => cat.id === selectedCategory)?.name}
                </h2>
                <div className="text-gray-600">
                  {sortedProducts.length} Produkte
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-product-shop>
                {sortedProducts.map((product) => (
                  <div key={product.id} className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
                    <div className="aspect-square bg-gray-50 p-6">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-contain object-top"
                      />
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                        {product.name}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                        {product.description}
                      </p>
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-2">
                          <span className="text-2xl font-bold text-blue-600">
                            {product.price}
                          </span>
                          {product.originalPrice && (
                            <span className="text-lg text-gray-400 line-through">
                              {product.originalPrice}
                            </span>
                          )}
                        </div>
                        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                          product.inStock 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-red-100 text-red-800'
                        }`}>
                          {product.inStock ? 'Verfügbar' : 'Nicht verfügbar'}
                        </div>
                      </div>
                      <div className="flex space-x-2">
                        <Link 
                          to={`/shop/produkt/${product.id}`}
                          className="flex-1"
                        >
                          <Button fullWidth variant="outline" size="sm" className="whitespace-nowrap">
                            <div className="w-4 h-4 flex items-center justify-center mr-2">
                              <i className="ri-eye-line"></i>
                            </div>
                            Details
                          </Button>
                        </Link>
                        <Button size="sm" className="px-4 whitespace-nowrap cursor-pointer">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-shopping-cart-line"></i>
                          </div>
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div className="flex justify-center items-center space-x-2 mt-12">
                <button className="px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-line"></i>
                  </div>
                </button>
                <button className="px-3 py-2 bg-blue-600 text-white rounded-lg cursor-pointer">1</button>
                <button className="px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">2</button>
                <button className="px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">3</button>
                <button className="px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">4</button>
                <button className="px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
